import Header from "@components/Header/Header"
import SectionLabel from "@components/SectionLabel/SectionLabel";
import { useNavigate } from "react-router";
import JIDRContainerDisplay from "@components/JIDRConfirmationDisplay/JIDRContainerDisplay";
import AccountListItem from "@components/AccountListItem/AccountListItem";
import { truncateAddress } from "@lib/utils";
import PrimaryButton from "@components/PrimaryButton/PrimaryButton";
import { useTranslation } from "react-i18next";
import {
    Container,
    BodyContainer,
    ContentContainer,
    TransferInfoContainer,
    DestinationContainer,
    DestinationLabel
} from "./P2PTransferConfirmation.styles";
import { ModalWithIcon } from "@components/ModalWithIcon/ModalWithIcon";
import { useState } from "react";
import useOngoingTransaction from "@hooks/useOngoingTransaction"
import LoadingModal from "@components/LoadingModal/LoadingModal";
import TemporaryTokenMigrationGuard from "@components/TemporaryTokenMigration/TemporaryTokenMigrationGuard/TemporaryTokenMigrationGuard";

const P2PTransferConfirmation = ({
    type,
    amount,
    address,
    name,
    save_address,
}: {
    type?: string,
    amount: number,
    address: string,
    name?: string,
    save_address?: boolean
}) => {
    const { data: ongoingTransactionInformation, isLoading } = useOngoingTransaction()
    const [showModal, setShowModal] = useState(false)

    const navigate = useNavigate();
    const { t } = useTranslation();
    const onBackClick = () => {
        if (type === 'one-time') {
            navigate('/p2p-one-time-transfer')
        } else {
            navigate('/p2p-transfer')
        }
    }

    const handlePay = () => {
        if (!ongoingTransactionInformation?.canCreateNewTransaction) {
            setShowModal(true)
            return
        }
        navigate('/authentication', {
            state: {
                operationData: JSON.stringify({
                    destination: address,
                    amount: amount,
                    name: name,
                    save_address: save_address
                }),
                operationType: 'p2p-transfer',
                headerTitle: t('p2p.confirmation.authentication.headerTitle'),
                description: t('p2p.confirmation.authentication.description'),
                useBiometrics: true
            }
        })
    }

    return (
        <Container>
            <Header title={t('p2p.confirmation.header')} showBackButton onBackClick={onBackClick} />
            <BodyContainer>
                <LoadingModal visible={isLoading} />
                <TemporaryTokenMigrationGuard />
                {showModal && <div style={{ zIndex: 2000 }}>
                    <ModalWithIcon
                        title={t('common.ongoingTransaction.title')}
                        description={t('common.ongoingTransaction.description')}
                        onPositive={onBackClick}
                        positiveText={t('common.ongoingTransaction.positiveText')}
                        type="void"
                        visible={showModal}
                        onModalOverlayClick={() => setShowModal(false)}
                    />
                </div>}
                <ContentContainer>
                    <TransferInfoContainer>
                        <SectionLabel>{t('p2p.confirmation.transferInformation')}</SectionLabel>
                        <JIDRContainerDisplay amount={amount} />
                    </TransferInfoContainer>
                    <DestinationContainer>
                        <DestinationLabel>
                            {t('p2p.confirmation.destination')}
                        </DestinationLabel>
                        <AccountListItem
                            iconUrl=""
                            accountNumber={truncateAddress(address, 13, 13)}
                            provider=""
                            noPicture={!name}
                            name={name}
                            profilePicturePlaceholder={name}
                            isValid={true}
                            onClick={() => { }}
                        />
                    </DestinationContainer>
                </ContentContainer>
                <PrimaryButton onClick={handlePay}>
                    {t('p2p.confirmation.confirmButton')}
                </PrimaryButton>
            </BodyContainer>
        </Container>
    )
}

export default P2PTransferConfirmation